import React from 'react'

function TableSpinner() {
  return (
    <div className="flex justify-center items-center w-full h-full">
    <div className="loader" /> {/* Or use your PulseLoader */}
  </div>
  )
}

export default TableSpinner